export default __webpack_public_path__ + "static/media/plus-time.1c2811d8.svg";